import { render, staticRenderFns } from "./FormLabel.vue?vue&type=template&id=0aa20af2"
import script from "./FormLabel.vue?vue&type=script&lang=js"
export * from "./FormLabel.vue?vue&type=script&lang=js"
import style0 from "./FormLabel.vue?vue&type=style&index=0&id=0aa20af2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../acquisition-wisemium/node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports